import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	hasReachedLimitLabel: {
		id: 'software-backlog.header.controls-bar.filter-bar.custom-filters.has-reached-limit-label',
		defaultMessage:
			'Custom filters is disabled because you have reached the maximum limit of 5000 work items',
		description: 'The tooltip message label of disabled custom filters.',
	},
});
